module.exports = __webpack_public_path__ + "img/export-icon.40ea1a8a.svg";